import React from "react";
import { Flex, Text } from "@mantine/core";
import CustomAnchor from "../../components/mantineCustomComponents/CustomAnchor";

// Function for creating data
export const reportsTableData = (reportsData, theme) => {
  if (!Array.isArray(reportsData)) {
    return [];
  }

  return reportsData.map((item) => ({
    targetAllocationsFile: (
      <Text lineClamp={2} title={item.target_allocations_file}>
        {item.target_allocations_file}
      </Text>
    ),
    trustedTimestamp: (
      <Text lineClamp={2} title={item.trusted_timestamp}>
        {item.trusted_timestamp}
      </Text>
    ),
    proofOfAuthenticity: (
      <Flex
        align={theme.flex.align.center}
        justify={theme.flex.justify.center}
        gap={theme.flex.gap.medium}
      >
        {item?.proof_of_authenticity_link_vbase && (
          <CustomAnchor
            text=""
            href={`/verify/?cid=${item?.proof_of_authenticity_link_vbase}`}
            target="_blank"
            rel="noopener noreferrer"
            componentClasses=""
            LogoVBSvgEnable="true"
          ></CustomAnchor>
        )}
        {item?.proof_of_authenticity_link_blockchain && (
          <CustomAnchor
            text=""
            href={item?.proof_of_authenticity_link_blockchain}
            target="_blank"
            rel="noopener noreferrer"
            LogoBlockchainSvgEnable="true"
            componentClasses=""
          ></CustomAnchor>
        )}

        {item?.proof_of_authenticity_pdf && (
          <CustomAnchor
            text=""
            href={item?.proof_of_authenticity_pdf}
            target="_blank"
            rel="noopener noreferrer"
            LogoPDFSvgEnable="true"
            componentClasses=""
          ></CustomAnchor>
        )}
      </Flex>
    ),
  }));
};

// Function for creating columns
export const reportsTableColumns = () => [
  {
    accessorKey: "targetAllocationsFile",
    header: "Target Allocations File",
    enableSorting: true,
    size: 150,
  },
  {
    accessorKey: "trustedTimestamp",
    header: "Trusted Timestamp",
    enableSorting: true,
    size: 280,
  },
  {
    accessorKey: "proofOfAuthenticity",
    header: "Proof of authenticity",
    enableSorting: false,
    size: 30,
    mantineTableBodyCellProps: {
      align: "center",
    },
  },
];

// Function for configuring the table
export const reportsTableOptions = (columns, data, faIcons, theme) => ({
  columns,
  data,
  icons: faIcons,
  paginationDisplayMode: "pages",
  enableFullScreenToggle: false,
  enableTopToolbar: false,
  enableBottomToolbar: true,
  enableColumnActions: false,
  initialState: { pagination: { pageIndex: 0, pageSize: 20 } },
  withColumnBorders: true,
  mantinePaginationProps: () => ({
    showRowsPerPage: false,
    color: theme.customBackgrounds.table,
    autoContrast: true,
    style: {
      paddingBottom: "1.75em",
    },
  }),
  mantineTableProps: {
    style: {
      border: "none",
      borderCollapse: "collapse",
    },
    className: "html-table-mantine",
  },
  mantinePaperProps: {
    withBorder: false,
    shadow: "none",
  },
  mantineTableBodyCellProps: {
    style: {
      padding: "0.6875em 0.9375em 0.5625em 0.9375em",
      fontSize: "1.142em",
    },
  },
  mantineTableHeadCellProps: {
    style: {
      padding: "0.55em 0.9375em 0.4375em 0.9375em",
      fontSize: "1.142em",
      fontFamily: theme.headings.fontFamily.bold,
    },
  },
  mantineTableBodyRowProps: () => ({
    style: {
      borderBottom: theme.customColors.tableBorder,
    },
  }),
  mantineTableHeadRowProps: () => ({
    style: {
      backgroundColor: theme.customBackgrounds.table,
    },
  }),
});
